export default (sirenAction, widgetId, currentPath) => () => {
    const target = sirenAction.targets?.[0];
    if (target) {
        const elementToFocus = document.querySelector(target);
        if (elementToFocus) elementToFocus.focus();
    }
};
